import { useTranslation } from '../../../../../utils/useTranslation';
import { IconShare } from '../../../../icon/IconShare';
import { Button } from '../../../../input/Button';
import { ShareButtonProps } from './types';

export const ShareButton = ({ onShare, ...other }: ShareButtonProps) => {
    const t = useTranslation();

    return (
        <Button
            {...other}
            flexGrow={1}
            variant="filled"
            size="m"
            color="secondary"
            spacing={0.5}
            onClick={onShare}
        >
            <IconShare size={20} />
            {t('Поделиться')}
        </Button>
    );
};
